import { gaWaitlistClick, gaWaitlistSubmit } from "./ga4";
import { trackLead } from "./metaPixel";

/** Meta custom event + GA4 event for waitlist CTA clicks (once per handler invocation). */
export function trackWaitlistClick() {
  window.fbq?.("trackCustom", "WaitlistClick");
  gaWaitlistClick();
}

/** Standard Meta Lead + GA4 waitlist_submit after a successful waitlist submission. */
export function trackWaitlistLead() {
  trackLead();
  gaWaitlistSubmit();
}
